module.exports = __webpack_public_path__ + "static/ac-b5d74aba595e9aee1bd6befa6e531ec1.svg";